import { render, staticRenderFns } from "./SubEmpresaAlertasContratos.vue?vue&type=template&id=69cbbda0&lang=pug"
import script from "./SubEmpresaAlertasContratos.vue?vue&type=script&lang=js"
export * from "./SubEmpresaAlertasContratos.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaAlertasContratos.vue?vue&type=style&index=0&id=69cbbda0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports